import * as React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { ConfigurationModel, WashBasinModel, AssemblyAccessoriesModel } from 'franke-trough-dependencies';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Tooltip, Button } from 'reactstrap';
import { requestAPIActions } from 'loopback-react-request';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './Assemblies.messages';

export interface ConsolesOverlapChoiceProps {
  plateBuilder: GlobalPrivateState['plateBuilder'];
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
  id: string;
  inline?: boolean;
  className?: string;
}

export interface ConsolesOverlapChoiceState {
  tooltipOpen: boolean;
  ignorableTrigger: boolean;
  selectedDecision: 'return' | 'continue' | 'change' | null;
}

export class ConsolesOverlapChoicePartial extends React.Component<ConsolesOverlapChoiceProps, ConsolesOverlapChoiceState> {
  constructor(props: ConsolesOverlapChoiceProps) {
    super(props);

    this.state = {
      tooltipOpen: false,
      ignorableTrigger: false,
      selectedDecision: null
    };
    this.toggle = this.toggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public render() {
    const hasOverlappingError =
      this.props.plateBuilder && this.props.plateBuilder.calc.hasOverlappingError();

    const currentConsole =
      (this.assemblyAccessories && this.assemblyAccessories.console) ||
      (this.props.configuration.result &&
        this.props.configuration.result.defaults.assemblyAccessories.console.default);

    const isMiranitConsole = currentConsole === 'miranit';
    const acceptedMiranitOverlap =
      this.assemblyAccessories && this.assemblyAccessories.acceptedMiranitOverlap;

    const showMiranitWarning =
      hasOverlappingError && isMiranitConsole && !acceptedMiranitOverlap;

    const showRevertWarning =
      hasOverlappingError && !isMiranitConsole;

    const showWarning = showMiranitWarning || showRevertWarning;

    const tollTipId = `plate_dimensions_required_tooltip_${this.props.id}`;

    if (!showWarning) {
      return null;
    }

    const infoIcon = (
      <span className={classNames('info-icon', this.props.className)} id={tollTipId}>
        <FontAwesomeIcon icon={faInfo} />
        <Tooltip
          autohide={false}
          isOpen={this.state.tooltipOpen}
          placement="top"
          toggle={this.toggle}
          target={tollTipId}
          className="tooltip-choice"
        >
          <p>
            <FormattedMessage {...(isMiranitConsole ? MESSAGES.consolesOverlapChoiceMessage : MESSAGES.consolesOverlapMessage)} />
          </p>

          {isMiranitConsole ? (
            <>
              <label>
                <input
                  type="radio"
                  name="decision"
                  value="return"
                  checked={this.state.selectedDecision === 'return'}
                  onClick={() => this.setState({ ignorableTrigger: true })}
                  onChange={(ev: React.SyntheticEvent<HTMLInputElement>) =>
                    this.handleChange(ev)
                  }
                />
                <FormattedMessage {...MESSAGES.consolesOverlapChoiceContinue} />
              </label>

              <label>
                <input
                  type="radio"
                  name="decision"
                  value="change"
                  checked={this.state.selectedDecision === 'change'}
                  onClick={() => this.setState({ ignorableTrigger: true })}
                  onChange={(ev: React.SyntheticEvent<HTMLInputElement>) =>
                    this.handleChange(ev)
                  }
                />
                <FormattedMessage {...MESSAGES.consolesOverlapChoiceChange} />
              </label>
            </>
          ) : null}

          <p className="text-right">
            <Button
              onClick={(ev: React.MouseEvent<HTMLButtonElement>) =>
                this.handleSubmit(ev, 'submit')
              }
              className="yes"
              disabled={isMiranitConsole && this.state.selectedDecision === null}
            >
              <FontAwesomeIcon icon={faCheck} />
            </Button>
          </p>
        </Tooltip>
      </span>
    );

    if (this.props.inline) {
      return infoIcon;
    }

    return (
      <div className="decision-wrapper warnings-wrapper">
        {infoIcon}
      </div>
    );
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>): void {
    const { value } = event.target as HTMLInputElement;

    this.setState({
      selectedDecision: value as any
    });
  }

  private dispatchConfiguration() {
    let configuration = this.props.configuration && this.props.configuration.result;
    if (!configuration) { return; }

    if (!configuration.assemblyAccessories) {
      configuration.assemblyAccessories = {
        console: configuration.defaults.assemblyAccessories.console.default,
        selection: configuration.defaults.assemblyAccessories.selection.default,
        acceptedMiranitOverlap: configuration.defaults.assemblyAccessories.acceptedMiranitOverlap.default
      };
    }

    const currentConsole = configuration.assemblyAccessories.console;
    const isMiranitConsole = currentConsole === 'miranit';

    if (!isMiranitConsole) {
      configuration = {
        ...configuration,
        ...configuration.prev
      };
    } else {
      if (this.state.selectedDecision === 'change') {
        configuration.assemblyAccessories.console = 'stainlessSteel';
      }

      if (this.state.selectedDecision === 'return') {
        configuration = {
          ...configuration,
          ...configuration.prev
        };
      }

      if (this.state.selectedDecision === 'continue') {
        configuration.assemblyAccessories.acceptedMiranitOverlap = true;
      }
    }

    this.props.dispatch(requestAPIActions.load(
      'configuration',
      {
        url: `/Configurations/${configuration && configuration.id}`,
        options: {
          method: 'PATCH',
          data: configuration
        },
      },
      true,
    ));
  }

  private handleSubmit(event: React.MouseEvent<HTMLButtonElement>, type: 'submit') {
    this.dispatchConfiguration();
  }

  private toggle() {
    if (this.state.ignorableTrigger) {
      this.setState({
        ignorableTrigger: false
      });
    } else {
      this.setState({
        tooltipOpen: !this.state.tooltipOpen
      });
    }
  }
 
  private get assemblyAccessories(): AssemblyAccessoriesModel | undefined {
    const {
      configuration,
    } = this.props;

    return configuration && 
      configuration.result && 
      configuration.result.assemblyAccessories ? 
        configuration.result.assemblyAccessories : undefined;
  }
}

export const ConsolesOverlapChoice = connect((state: GlobalPrivateState) => ({
  plateBuilder: state.plateBuilder,
  configuration: state.configuration,
}))(ConsolesOverlapChoicePartial);

export default ConsolesOverlapChoice;


